<template>
  <a-col :span="12">
    <a-form-item label="数值字段">
      <a-input
        v-if="!remote"
        v-model:value="config.valueKey"
        allow-clear
      />
      <a-auto-complete
        v-else
        v-model:value="config.valueKey"
        :options="options"
        :loading="loading"
        placeholder="请输入数值字段"
        allow-clear
        :filter-option="filterOptionContains"
      />
    </a-form-item>
  </a-col>
  <a-col
    v-if="!remote || config.labelKeyType === 1"
    :span="12"
  >
    <a-form-item label="显示字段">
      <a-input
        v-if="!remote"
        v-model:value="config.labelKey"
        allow-clear
      />
      <a-auto-complete
        v-else
        v-model:value="config.labelKey"
        :options="options"
        :loading="loading"
        placeholder="请输入显示字段"
        allow-clear
        :filter-option="filterOptionContains"
      />
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 数值字段/显示字段配置（共享）：
   本地选项组件（select/radio/checkbox/groupselect/treeselect/cascader）用 a-input；
   远程组件用 a-auto-complete（候选来自数据源字段列表，labelKeyType=2 时 labelKey 由 labelKeyList 编辑）。 */
import { computed } from 'vue';

const props = defineProps<{
  config: any;
  remote?: boolean;
  options?: any[]; // 远程字段候选（value/label）
  loading?: boolean;
}>();

const remote = computed(() => !!props.remote);
const filterOptionContains = (input: string, option: any) =>
  !input || (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
</script>
